// Round-robin color allocator for new layers. The palette is picked to read
// well against both the dark and light canvas backgrounds.

export const PALETTE = [
  "#4FC3F7", "#81C784", "#FFB74D", "#F06292",
  "#CE93D8", "#4DD0E1", "#AED581", "#FF8A65",
  "#90A4AE", "#FFD54F", "#64B5F6", "#A1887F",
  "#EF5350", "#26C6DA", "#AB47BC", "#FFA726",
  "#66BB6A", "#42A5F5", "#EC407A", "#26A69A",
  "#7E57C2", "#FF7043", "#5C6BC0", "#8D6E63",
];

export function nextColor(used: string[]): { color: string; used: string[] } {
  for (const color of PALETTE) {
    if (!used.includes(color)) {
      return { color, used: [...used, color] };
    }
  }
  // Palette exhausted — start over.
  const color = PALETTE[0]!;
  return { color, used: [color] };
}

export function releaseColor(used: string[], color: string): string[] {
  const idx = used.indexOf(color);
  if (idx < 0) return used;
  const next = used.slice();
  next.splice(idx, 1);
  return next;
}
